import React from 'react';
import { useTranslation } from 'react-i18next';
import "./style.css";
import background from "./img/background1.jpg"
import { Accordion } from "platformscode-react";
import useLanguageSetup from "./useLanguageSetup.js";
import { useEffect, useState, ChangeEvent } from "react";
import { changeLanguage } from 'i18next';



function App() {

     useLanguageSetup();
    const { t } = useTranslation();

 
    const accordionsData = [
        {
            title: t("accordionCustomerCharter.items.0.title"),
            content: (
                <div className="space-y-2">
                    {t("accordionCustomerCharter.items.0.content").split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>

            )
        },

        {
            title: t("accordionCustomerCharter.items.1.title"),
            content: (
                <div className="space-y-2">
                    {t("accordionCustomerCharter.items.1.content").split('\n').map((line, i) => (
                        <p key={i}>{line}</p>
                    ))}
                </div>

            )
        },

        {
            title: t("accordionCustomerCharter.items.2.title"),
            content: (
                <div className="space-y-4">
                    <p >{t("accordionCustomerCharter.items.2.content")} </p>
                    <ul className="list-disc list-inside space-y-3 ">
                        <li className="text-primary link " style={{ display: 'list-item' }} dangerouslySetInnerHTML={{ __html: t("accordionCustomerCharter.items.2.link1") }} />
                        <li className="text-primary link " style={{ display: 'list-item' }} dangerouslySetInnerHTML={{ __html: t("accordionCustomerCharter.items.2.link2") }} />
                    </ul>
                    <p>{t("accordionCustomerCharter.items.2.note")}</p>
                </div>
            )
        }



    ];


    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = accordionsData.slice(startIndex, endIndex);





    return (
        <>

            {/* Page Title */}
            < div className=" flex flex-col gap-[16px] lg:px-[80px] px-[var(--spacing-xl,16px)] bg-[var(--background-primary-25,#F7FDF9)] py-[45px] mb-[40px]"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }} >

                <h1 className="text-[var(--text-default,#161616)] text-[40px] leading-[60px] font-[600] tracking-[-0.96px] mb-[40px]">
                    {t('CustomerCharter')}
                </h1>
            </div >


            <div className="py-[calc(var(--spacing-3xl,24px))] lg:py-[calc(var(--spacing-4xl,32px))] !pb-0">
                <div className="lg:px-[var(--spacing-8xl,80px)] px-[var(--spacing-xl,16px)] mb-[40px]">

                    {currentItems.map((item, index) => (
                        <Accordion
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>
            </div>





        </>
    );
}

export default App;
